<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item class="style" prop="identity" label="超级管理员身份">
          <div>
            <el-radio-group v-model="ruleForm.identity">
              <el-radio :label="'0'">法定代表人/经营者</el-radio>
              <el-radio :label="'1'">负责人</el-radio>
            </el-radio-group>
            <el-tooltip
              class="item"
              effect="light"
              content="若超管身份是负责人，则该商户入驻流程为：提交申请-平台审核-账户验证-超管签约-完成入驻"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="超级管理员姓名" prop="contactName">
          <el-input v-model="ruleForm.contactName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="超级管理员身份证件号码" prop="contactIdNumber">
          <el-input v-model="ruleForm.contactIdNumber" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="超级管理员微信openid" prop="openid">
          <div class="style"><el-input v-model="ruleForm.openid" placeholder="" clearable></el-input></div>
          <p class="labels-tips">
            请填写超级管理员的微信openid，超级管理员签约时，校验超级管理员微信是否与该微信openid一致。
          </p>
        </el-form-item>
        <el-form-item label="联系手机" prop="mobilePhone">
          <div class="style">
            <el-input v-model="ruleForm.mobilePhone" placeholder="" clearable>
              <template slot="prepend">+86</template>
            </el-input>
          </div>
          <p class="labels-tips">
            用于接收微信支付的重要管理信息及日常操作验证码，超管签约时可自助修改手机号，并进行短信验证。
          </p>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <div class="style"><el-input v-model="ruleForm.contactEmail" placeholder="" clearable></el-input></div>
          <p class="labels-tips">用于接收微信支付的开户邮件及日常业务通知。</p>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        identity: '0',
        contactName: '',
        contactIdNumber: '',
        openid: '',
        mobilePhone: '',
        contactEmail: '',
      },
      rules: {
        identity: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        contactName: [{ required: true, message: '请输入超级管理员姓名', trigger: ['blur', 'change'] }],
        contactIdNumber: [{ required: true, message: '请输入超级管理员身份证件号码', trigger: ['blur', 'change'] }],
        openid: [{ required: true, message: '请输入超级管理员微信openid', trigger: ['blur', 'change'] }],
        mobilePhone: [{ required: true, message: '请输入超级管理员联系手机', trigger: ['blur', 'change'] }],
        contactEmail: [{ required: true, message: '请输入超级管理员联系邮箱', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.superAdministratorInformationVO) {
          this.ruleForm = data.superAdministratorInformationVO;
        }
      },
    },
  },

  methods: {
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
